module.exports = __webpack_public_path__ + "static/media/download.326a31e2.svg";